import api from "../services/authService";

// Sharing a matter's folders with an outside expert (the Mednick portal).
//
// Distinct from the external-share wrappers in service/matter.js and
// service/externalFolderShare.js, which mint public links to one document
// or one folder. This is a named person at a named firm, signing in with
// a passkey, reading the folders a paralegal ticked — so the unit is a
// grant that can be re-ticked and revoked, not a token.

export const fetchPortalShareOptions = async (matterId) => {
  const response = await api.get(`/matters/${matterId}/portal-share/`);
  return response;
};

// Cheap enough to ask on every visit to a file: how many outside readers
// it has and which folders are exposed. Deliberately not folded into the
// matter payload, which is cached for five minutes — a stale "not shared"
// is the one wrong answer this must never give.
export const fetchPortalShareSummary = async (matterId) => {
  const response = await api.get(`/matters/${matterId}/portal-share/summary/`);
  return response;
};

export const createPortalShare = async (matterId, payload) => {
  const response = await api.post(`/matters/${matterId}/portal-share/`, payload);
  return response;
};

export const updatePortalShare = async (matterId, grantId, payload) => {
  const response = await api.patch(
    `/matters/${matterId}/portal-share/${grantId}/`,
    payload
  );
  return response;
};

export const revokePortalShare = async (matterId, grantId, reason = "") => {
  const response = await api.delete(
    `/matters/${matterId}/portal-share/${grantId}/`,
    { params: reason ? { reason } : undefined }
  );
  return response;
};
